import Script from 'next/script'
import md5 from 'md5'
import { normalizeCarriageReturns } from '@bluheadless/ui-logic/src/utils/string'

export const parseScript = (node, { idPrefix, ...scriptProps } = { idPrefix: 'script' }) => {
	const { id, src, ...restAttribs } = node.attribs

	if (src) {
		return <Script {...scriptProps} {...restAttribs} id={id || scriptProps.id} src={src} />
	} else if (node.children?.length > 0) {
		const scriptId = Object.keys(node.attribs).includes('bh-reinit')
			? undefined
			: id || scriptProps.id || `${idPrefix}_${md5(normalizeCarriageReturns(node.children[0].data))}`

		return (
			<Script
				{...scriptProps}
				{...restAttribs}
				id={scriptId}
				dangerouslySetInnerHTML={{
					__html: normalizeCarriageReturns(node.children[0].data),
				}}
			/>
		)
	} else {
		return <></>
	}
}
